// extracted by mini-css-extract-plugin
export default {"left":"JLpidffCik","right-name":"B3ZXwOKhFL","rightName":"B3ZXwOKhFL","right":"_2mD0JuPWgG","secret-inspector":"_1G0fd_W67B","secretInspector":"_1G0fd_W67B","description":"_3BYYmlPuDm"};
    if(module.hot) {
      // 1627035492422
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  